import { baseUniDriverFactory } from '../../../utils/test-utils/unidriver';

import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface CardContentUniDriver extends BaseUniDriver {
  /** Returns size property value. */
  getSize(): Promise<string | null>;
}

export const headerUniDriverFactory = (
  base: UniDriver,
): CardContentUniDriver => {
  return {
    ...baseUniDriverFactory(base),
    getSize: () => base.attr('data-size'),
  };
};
